(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["binky-home-collections-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('binky-media-slider')) {
    class BinkyMediaSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.slides = Array.from(this.querySelectorAll('[data-binky-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-binky-slider-dot]'));
        this.count = this.slides.length;
        this.index = 0;
        this.timer = null;
        this.isAnimating = false;
        this.transitionMs = Number(this.dataset.transition || 700);
        this.intervalMs = Number(this.dataset.interval || 4000);
        this.transitionStyle = this.dataset.transitionStyle || 'slide_left';
        this.easingName = this.dataset.easing || 'smooth';
        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseHover = this.dataset.pauseHover === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.style.setProperty('--binky-motion-duration', Math.max(2500, this.intervalMs + this.transitionMs) + 'ms');

        if (this.count > 0) {
          this.slides.forEach((slide) => {
            slide.classList.remove('is-active', 'is-entering', 'is-leaving');
          });
          this.slides[0].classList.add('is-active');
        }

        this.classList.add('is-ready');
        this.updateDots();

        if (this.count < 2) return;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const target = Number(dot.dataset.binkySliderDot || 0);
            const direction = target >= this.index ? 1 : -1;
            this.goTo(target, direction);
            this.restart();
          });
        });

        this.pointerStartX = null;
        this.pointerStartY = null;

        this.addEventListener('pointerdown', (event) => {
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
        });

        this.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null || this.pointerStartY === null) return;

          const dx = event.clientX - this.pointerStartX;
          const dy = event.clientY - this.pointerStartY;
          this.pointerStartX = null;
          this.pointerStartY = null;

          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;

          if (dx < 0) {
            this.next();
          } else {
            this.prev();
          }

          this.restart();
        });

        if (this.pauseHover) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }

        this.visibilityHandler = () => {
          if (document.hidden) this.stop();
          else this.start();
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.start();
              else this.stop();
            });
          }, { threshold: 0.2 });
          this.observer.observe(this);
        } else {
          this.start();
        }
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.visibilityHandler) {
          document.removeEventListener('visibilitychange', this.visibilityHandler);
        }
      }

      get easing() {
        const easings = {
          smooth: 'cubic-bezier(.22,.61,.36,1)',
          soft: 'cubic-bezier(.33,1,.68,1)',
          snappy: 'cubic-bezier(.2,.8,.2,1)',
          linear: 'linear'
        };

        return easings[this.easingName] || easings.smooth;
      }

      getFrames(direction) {
        const forward = direction >= 0 ? 1 : -1;

        switch (this.transitionStyle) {
          case 'slide_right': {
            const sign = -forward;
            return {
              leaving: [
                { transform: 'translate3d(0,0,0)', opacity: 1 },
                { transform: 'translate3d(' + (100 * sign) + '%,0,0)', opacity: 1 }
              ],
              entering: [
                { transform: 'translate3d(' + (-100 * sign) + '%,0,0)', opacity: 1 },
                { transform: 'translate3d(0,0,0)', opacity: 1 }
              ]
            };
          }

          case 'slide_up':
            return {
              leaving: [
                { transform: 'translate3d(0,0,0)', opacity: 1 },
                { transform: 'translate3d(0,' + (-100 * forward) + '%,0)', opacity: 1 }
              ],
              entering: [
                { transform: 'translate3d(0,' + (100 * forward) + '%,0)', opacity: 1 },
                { transform: 'translate3d(0,0,0)', opacity: 1 }
              ]
            };

          case 'fade':
            return {
              leaving: [{ opacity: 1 }, { opacity: 0 }],
              entering: [{ opacity: 0 }, { opacity: 1 }]
            };

          case 'fade_zoom':
            return {
              leaving: [
                { opacity: 1, transform: 'scale(1)' },
                { opacity: 0, transform: 'scale(1.015)' }
              ],
              entering: [
                { opacity: 0, transform: 'scale(1.04)' },
                { opacity: 1, transform: 'scale(1)' }
              ]
            };

          case 'reveal': {
            const enteringClip = forward > 0
              ? 'inset(0 100% 0 0)'
              : 'inset(0 0 0 100%)';

            return {
              leaving: [{ opacity: 1 }, { opacity: 1 }],
              entering: [
                { opacity: 1, clipPath: enteringClip },
                { opacity: 1, clipPath: 'inset(0 0 0 0)' }
              ]
            };
          }

          case 'slide_left':
          default:
            return {
              leaving: [
                { transform: 'translate3d(0,0,0)', opacity: 1 },
                { transform: 'translate3d(' + (-100 * forward) + '%,0,0)', opacity: 1 }
              ],
              entering: [
                { transform: 'translate3d(' + (100 * forward) + '%,0,0)', opacity: 1 },
                { transform: 'translate3d(0,0,0)', opacity: 1 }
              ]
            };
        }
      }

      transitionTo(targetIndex, direction = 1) {
        if (this.count < 2 || this.isAnimating || targetIndex === this.index) return;

        const current = this.slides[this.index];
        const next = this.slides[targetIndex];
        if (!current || !next) return;

        const duration = this.reducedMotion ? 0 : this.transitionMs;
        const frames = this.getFrames(direction);

        this.isAnimating = true;
        current.classList.add('is-leaving');
        next.classList.add('is-entering');

        const finish = () => {
          current.classList.remove('is-active', 'is-leaving');
          next.classList.remove('is-entering');
          next.classList.add('is-active');

          this.index = targetIndex;
          this.isAnimating = false;
          this.updateDots();
        };

        if (duration === 0 || typeof current.animate !== 'function' || typeof next.animate !== 'function') {
          finish();
          return;
        }

        const options = {
          duration,
          easing: this.easing,
          fill: 'forwards'
        };

        const leavingAnimation = current.animate(frames.leaving, options);
        const enteringAnimation = next.animate(frames.entering, options);

        Promise.all([
          leavingAnimation.finished.catch(() => {}),
          enteringAnimation.finished.catch(() => {})
        ]).then(() => {
          finish();
          leavingAnimation.cancel();
          enteringAnimation.cancel();
        });
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.index);
          dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
        });
      }

      next() {
        if (this.count < 2) return;
        const target = (this.index + 1) % this.count;
        this.transitionTo(target, 1);
      }

      prev() {
        if (this.count < 2) return;
        const target = (this.index - 1 + this.count) % this.count;
        this.transitionTo(target, -1);
      }

      goTo(target, direction = 1) {
        if (this.count < 2) return;
        const normalized = Math.max(0, Math.min(target, this.count - 1));
        this.transitionTo(normalized, direction);
      }

      start() {
        if (!this.autoplay || this.reducedMotion || this.count < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.next(), Math.max(2000, this.intervalMs));
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    customElements.define('binky-media-slider', BinkyMediaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
